import { Divider, Stack, Typography } from "@mui/material";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { neutral } from "@flat-ui";
import {
  DEFAULT_BOLD_TEXT_FONT_WEIGHT,
  DEFAULT_TEXT_FONT_SIZE,
} from "@styles/common-styles";
import { CSSProperties } from "react";

interface Props {
  /** The team data to be displayed */
  team: FaroCoreApiTypes.Team;
}

/** Style for the font inside the tooltip */
const textStyle: CSSProperties = {
  color: neutral[800],
  fontSize: DEFAULT_TEXT_FONT_SIZE,
};

/** General padding for the tooltip */
const paddingSize: CSSProperties["padding"] = "8px";

/** Shows a tooltip with the name and description of a team */
export function TeamNameTooltip({ team }: Props): JSX.Element {
  return (
    <Stack component="div" paddingX={paddingSize}>
      <Typography
        component={"var"}
        fontWeight={DEFAULT_BOLD_TEXT_FONT_WEIGHT}
        paddingY={paddingSize}
        sx={textStyle}
      >
        {team.name}
      </Typography>

      {/* Only show description if it exists */}
      {team.description && (
        <>
          <Divider />

          <Typography component={"var"} paddingY={paddingSize} sx={textStyle}>
            {team.description}
          </Typography>
        </>
      )}
    </Stack>
  );
}
